import { Link } from "react-router-dom";
import { useSite } from "../context/SiteContext";

export const PageHeader = ({ eyebrow, title, lead, crumb, image, imageAlt }) => {
  const { settings } = useSite();
  const logo = settings?.logo_path || "/lemur-logo.png";
  return (
    <section className={`page-hero${image ? " has-photo" : ""}`} data-testid="page-header">
      {image && (
        <div className="page-hero-photo" aria-hidden={imageAlt ? undefined : "true"}>
          <img src={image} alt={imageAlt || ""} />
        </div>
      )}
      <div className="watermark" style={{ right: "-90px", top: "-60px", width: "360px", height: "360px", opacity: 0.06 }} aria-hidden="true">
        <img src={logo} alt="" />
      </div>
      <div className="wrap">
        <div className="page-hero-in">
          {eyebrow && <span className="eyebrow light">{eyebrow}</span>}
          <h1>{title}</h1>
          {lead && <p>{lead}</p>}
          <nav className="breadcrumb" aria-label="Breadcrumb">
            <Link to="/">Home</Link>
            {crumb && (<><span>/</span><span style={{ color: "rgba(255,255,255,.85)" }}>{crumb}</span></>)}
          </nav>
        </div>
      </div>
    </section>
  );
};
